
import { useStrategiesData } from "./strategies/useStrategiesData";
import { useCreateStrategy } from "./strategies/useCreateStrategy";
import { useUpdateStrategy } from "./strategies/useUpdateStrategy";
import { useDeleteStrategy } from "./strategies/useDeleteStrategy";
import { useStrategyStatus } from "./strategies/useStrategyStatus";
import { useApproveStrategy } from "./strategies/useApproveStrategy";
import { Strategy, StrategyWithDetails } from "@/types/strategy-types";

export const useAdminStrategies = (providerId?: string | null) => {
  const { strategies, loading, loadStrategies } = useStrategiesData(providerId);
  const { createStrategy } = useCreateStrategy(loadStrategies, providerId);
  const { updateStrategy } = useUpdateStrategy(loadStrategies);
  const { deleteStrategy } = useDeleteStrategy(loadStrategies);
  const { toggleStrategyStatus, toggleStrategyActive } = useStrategyStatus(loadStrategies);
  const { approveStrategy } = useApproveStrategy(loadStrategies);

  return { 
    strategies, 
    loading, 
    loadStrategies, 
    createStrategy,
    updateStrategy,
    deleteStrategy,
    toggleStrategyStatus,
    toggleStrategyActive,
    approveStrategy
  };
};
